import { SeedSource } from "authoring/lib/enum/seed-source.mjs"

export function areAllSchedulesNew(schedules = []) {
    return schedules.length > 0 && schedules.every((schedule) => schedule?.seedSource === SeedSource.NEW)
}
